import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import Login from './components/Login';
import AdminDashboard from './components/AdminDashboard';
import Unauthorized from './components/Unauthorized';
import ProtectedRoute from './components/ProtectedRoute';
import MerchantEvent from './components/MerchantEvent';
import { isAuthenticated, getUserRole } from './utils/auth';
import Agents from './components/Agents';
import Files from './components/Files';
import Newsletter from './components/Newsletter';
import Users from './components/Users';
import WAChats from './components/WAChats';
import MBC from './components/MBC';
import SFUnits from './components/SFUnits';
import WinterOffer from './components/WinterOffer';
import WinterOfferDetail from './components/WinterOfferDetail';
import FajrCity from './components/FajrCity';
import { MerchantsPage } from './components/offer/merchants';
import { Card, Button } from 'antd';
import { ScanOutlined } from '@ant-design/icons';
import { getCurrentUser } from './utils/auth';
import { useAdminDashboard } from './components/AdminDashboard';
import './styles/responsive.css';

// Компоненты страниц
const DashboardPage: React.FC = () => {
  const currentUser = getCurrentUser();
  const { openScannerModal } = useAdminDashboard();

  return (
    <div>
      <Card title="Admin Dashboard">
        <p>Welcome to the Admin Dashboard</p>
        <p>Role: {currentUser?.role}</p>
      </Card>
      
      <Card title="QR Scanner" style={{ marginTop: 16 }}>
        <p>Scan QR codes to quickly access agent information.</p>
        <Button 
          type="primary" 
          icon={<ScanOutlined />}
          size="large"
          onClick={openScannerModal}
        >
          Scan QR Code
        </Button>
      </Card>
    </div>
  );
};

const AgentsPage: React.FC = () => <Agents />;
const FilesPage: React.FC = () => <Files />;
const NewsletterPage: React.FC = () => <Newsletter />;
const UsersPage: React.FC = () => <Users />;
const WAChatsPage: React.FC = () => <WAChats />;
const MBCAgentsPage: React.FC = () => <MBC />;
const SFUnitsPage: React.FC = () => <SFUnits />;
const WinterOfferPage: React.FC = () => <WinterOffer />;
const WinterOfferDetailPage: React.FC = () => <WinterOfferDetail />;
const FajrCityPage: React.FC = () => <FajrCity />;
const OfferMerchantsPage: React.FC = () => <MerchantsPage />;

const App: React.FC = () => {
  const getDashboardRedirect = () => {
    if (!isAuthenticated()) return "/login";
    
    const userRole = getUserRole();
    if (userRole === 'merchant') {
      return '/merchant/event';
    }
    
    // All other authenticated users go to admin dashboard
    return '/admin/dashboard';
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#1890ff',
        },
      }}
    >
      <AntApp>
        <Router>
          <Routes>
            <Route 
              path="/login" 
              element={<Login />} 
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="agents" element={<AgentsPage />} />
              <Route path="offer/merchants" element={<OfferMerchantsPage />} />
              <Route path="files" element={<FilesPage />} />
              <Route path="newsletter" element={<NewsletterPage />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="wa/chats" element={<WAChatsPage />} />
              <Route path="mbc/agents" element={<MBCAgentsPage />} />
              <Route path="sf/units" element={<SFUnitsPage />} />
              <Route path="winter/kids" element={<WinterOfferPage />} />
              <Route path="winter/kids/:merchantId" element={<WinterOfferDetailPage />} />
              <Route path="fajr/city" element={<FajrCityPage />} />
            </Route>
            <Route
              path="/merchant/event"
              element={
                <ProtectedRoute>
                  <MerchantEvent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/merchant"
              element={<Navigate to="/merchant/event" replace />}
            />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route 
              path="/dashboard" 
              element={<Navigate to={getDashboardRedirect()} replace />} 
            />
            <Route 
              path="/" 
              element={<Navigate to={getDashboardRedirect()} replace />} 
            />
          </Routes>
        </Router>
      </AntApp>
    </ConfigProvider>
  );
};

export default App;